import { useEffect, useState } from "react";

export default function NewPageIframe() {
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const title = params.get("title");
    const url = params.get("url");

    if (title) document.title = title;
    if (url) setIframeUrl(url);
  }, []);

  return (
    <div className="w-full">
      <iframe
        src={iframeUrl}
        className="w-full h-screen border-0"
        title="Embedded Page"
      />
    </div>
  );
}
